<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import ContactsAPI from 'dashboard/api/contacts';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const isLoading = ref(true);
const groups = ref([]);

const goToGroup = id => {
  router.push({
    name: 'contacts_edit',
    params: { accountId: route.params.accountId, contactId: id },
  });
};

const fetchGroups = async () => {
  isLoading.value = true;
  try {
    const { data } = await ContactsAPI.getContactGroups(route.params.contactId);
    groups.value = data.groups || [];
  } catch {
    groups.value = [];
    useAlert(t('CONTACTS_LAYOUT.SIDEBAR.GROUPS.FETCH_ERROR'));
  } finally {
    isLoading.value = false;
  }
};

onMounted(fetchGroups);
watch(() => route.params.contactId, fetchGroups);
</script>

<template>
  <div
    v-if="isLoading"
    class="flex items-center justify-center py-10 text-n-slate-11"
  >
    <Spinner />
  </div>
  <p
    v-else-if="groups.length === 0"
    class="px-6 py-10 text-sm leading-6 text-center text-n-slate-11"
  >
    {{ t('CONTACTS_LAYOUT.SIDEBAR.GROUPS.EMPTY') }}
  </p>
  <ul v-else class="px-6 py-4 flex flex-col gap-2">
    <li
      v-for="g in groups"
      :key="g.id"
      class="flex items-center justify-between gap-2 py-1 border-b border-n-strong last:border-b-0 cursor-pointer hover:text-n-brand"
      @click="goToGroup(g.id)"
    >
      <span class="text-sm text-n-slate-12 truncate">{{ g.name }}</span>
      <span
        v-if="g.left_at"
        class="text-[10px] uppercase tracking-wide px-2 py-0.5 rounded bg-n-alpha-3 text-n-slate-11"
      >
        {{ t('CONTACTS_LAYOUT.SIDEBAR.GROUPS.LEFT_BADGE') }}
      </span>
    </li>
  </ul>
</template>
